export class AppVersion {
	constructor(
		public id: 'version',
		public min_android_version: string,
		public min_ios_version: string,
		public min_smartkeyProxy_version: string,
		public current_smartkeyProxy_version: string
	) {}
}
